// Formatting helpers used by the website. Kept centralized so the institutional
// register stays consistent — every score, every confidence interval, every
// week label is rendered through this file.

export function formatScore(value: number): string {
  return value.toFixed(1);
}

export function formatCI(ci: [number, number]): string {
  // En-dash, not hyphen. This is the dash that ranges use in published prose.
  return `[${ci[0].toFixed(1)}\u2013${ci[1].toFixed(1)}]`;
}

export function formatN(n: number): string {
  // Tabular thousands separator using the en-space convention used in
  // statistical bulletins. Falls back to a normal comma in browsers that do
  // not support the separator option.
  return `n\u00A0=\u00A0${n.toLocaleString('en-US')}`;
}

export function formatRank(rank: number | null): string {
  return rank === null ? '\u2014' : String(rank);
}

export function formatRankChange(change: number): { glyph: string; label: string; tone: 'up' | 'down' | 'flat' } {
  if (change > 0) return { glyph: '\u25B3', label: `up ${change}`, tone: 'up' };
  if (change < 0) return { glyph: '\u25BD', label: `down ${Math.abs(change)}`, tone: 'down' };
  return { glyph: '\u2014', label: 'no change', tone: 'flat' };
}

export function formatWeekRange(weekSlug: string): string {
  // weekSlug is "YYYY-MM-DD_to_YYYY-MM-DD"
  const [from, to] = weekSlug.split('_to_');
  return `${from}\u00A0\u2192\u00A0${to}`;
}

export function formatWeekLabel(week: number, weekSlug: string): string {
  return `Week ${week} \u00B7 ${formatWeekRange(weekSlug)}`;
}

export function formatPercent(value: number, fractionDigits = 0): string {
  return `${(value * 100).toFixed(fractionDigits)}%`;
}

export function formatLargeInt(value: number): string {
  return value.toLocaleString('en-US');
}

export function formatCostUSD(value: number): string {
  return `$${value.toFixed(2)}`;
}

export function formatGeneratedAt(iso: string): string {
  const d = new Date(iso);
  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  const hh = String(d.getUTCHours()).padStart(2, '0');
  const mi = String(d.getUTCMinutes()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd} ${hh}:${mi} UTC`;
}

export function formatPostDate(iso: string): string {
  const d = new Date(iso);
  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
